import SortUtils from "../SortUtils";


export default class InspectionUtils extends SortUtils {

  static SortByCreatedDate = function (a, b) {
    return SortUtils.SortBy_createdDateAz(a,b);
  }

  static SortBy_name = function (a, b) {
    return SortUtils.SortBy_nameAz(a, b);
  }

  static SortBy_nameAz = function (a, b) {
    return SortUtils.SortBy("name", a, b);
  }

  static SortBy_nameZa = function (a, b) {
    return SortUtils.SortByDesc("name", a, b);
  }

  static SortBy_createdDateAz = function (a, b) {
    return SortUtils.SortBy("createdDate", a, b);
  }

  static SortBy_createdDateZa = function (a, b) {
    return SortUtils.SortByDesc("createdDate", a, b);
  }
  
  static SortBy_dateZa = function (a, b) {
    return SortUtils.SortByDesc("date", a, b);
  }

  static SortBy_dateAz = function (a, b) {
    return SortUtils.SortBy("date", a, b);
  }

  static SortBy_contractStartDateAz = function (a, b) {
    return SortUtils.SortBy("contractStart", a, b);
  }

  static SortBy_contractStartDateZa = function (a, b) {
    return SortUtils.SortByDesc("contractStart", a, b);
  }
}